import { Component } from '@angular/core';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  standalone: false,
  styleUrl: './hero.component.scss'
})
export class HeroComponent {}
